"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_world(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4b4f4354-4b85-4815-8ee6-d0668f52e001",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "country-or-international"), /*#__PURE__*/React.createElement("g", {
    id: "b1774fd7-7ddf-4f0a-ae11-bdf46ac8a130",
    "data-name": "Country_or_International_ic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "54311f19-75fa-4842-afe3-f7a5b10d16ad",
    "data-name": "<Pfad>",
    d: "M102.24,20.22C124.33,39.9,140,66.54,140,96c0,29.13-16.1,56.17-37.76,75.78",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dec1134b-1491-4cf1-9caa-2cdeeb9861e9",
    "data-name": "<Pfad>",
    d: "M89.76,20.22C67.67,39.9,52,66.54,52,96c0,29.13,16.1,56.17,37.76,75.78",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "77b4843f-b439-47a1-80f5-a6ca0004a7ed",
    "data-name": "<Pfad>",
    x1: 4,
    y1: 80,
    x2: 156,
    y2: 80,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "4083ad55-b154-47db-918a-893d4e9a863e",
    "data-name": "<Pfad>",
    x1: 80,
    y1: 156,
    x2: 80,
    y2: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7bd107de-a129-42ec-b4bc-0526aa3ff60d",
    "data-name": "<Pfad>",
    d: "M154.27,47.19C137,59.61,117.8,68,96,68c-21.52,0-40.92-8.44-58.26-20.81",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e8ab4331-18d3-4638-9c8c-9f7420840d45",
    "data-name": "<Pfad>",
    d: "M37.76,144.81C55,132.39,74.22,124,96,124c21.52,0,40.92,8.44,58.26,20.81",
    transform: "translate(-16 -16)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _default = ic_world;
exports.default = _default;